module.exports = __webpack_public_path__ + "static/media/anne-laure-conversation-mobile.e22d1bad.png";